// extracted by mini-css-extract-plugin
export var container = "_4x-0";
export var disabled = "_4x-4";
export var fullWidth = "_4x-3";
export var lined = "_4x-1";
export var selected = "_4x-5";
export var tab = "_4x-2";